import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    ThirdPartyPayoff,
    WireInstructions,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UpdateThirdPartyPayoffWireInstructionsRequest {
    engagementId: number;
    tableRowId: number;
    instructions: WireInstructions;
}

// ONE save per popup (D4) — never a PUT per field. PII: the payload carries
// real bank details; the error notification stays generic and no field value
// may ever be echoed into a message or a log.
export const UpdateThirdPartyPayoffWireInstructions = createAsyncThunk(
    'flowOfFunds/updateThirdPartyPayoffWireInstructions',
    async (
        params: UpdateThirdPartyPayoffWireInstructionsRequest,
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/wireInstructions`,
                params.instructions
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the wire instructions');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not save the wire instructions.', 'error');
            throw error;
        }
    }
);
